const offers = [
  {
    id: 1,
    name: "Do you need to automate your financial processes?",
    info: 'Open ECX automates financial processes like invoicing, ordering, and statement reconciliation.',
    logo: "/images/offers-images/logos/openecx.webp",
    backgroundImg:
      "/images/offers-images/backgrounds/banner.png",
    imgAlt: "Open ECX",

    overlayId: 1,
    overlayText:
      "Open ECX automates financial processes like invoicing, ordering, and statement reconciliation. Their solutions integrate with ERP systems, reducing manual work, errors, and processing times for businesses.",
    overlayLinkName: "Find out more.",
    overlayOfferLink: "https://openecx.com",
  },
  {
    id: 2,
    name: "Are you looking for graduate talent and training services?",
    info: "Furza specializes in sales enablement and graduate recruitment, developing graduate talent into future sales leaders.",
    logo: "/images/offers-images/logos/furza.png",
    backgroundImg: "/images/offers-images/backgrounds/banner.png",
    imgAlt: "Furza",

    overlayId: 2,
    overlayText:
      "Furza specializes in sales enablement and graduate recruitment, developing graduate talent into future sales leaders. They provide training programs, coaching, and career development to help businesses build high-performing sales teams.",
    overlayLinkName: "Find out more.",
    overlayOfferLink: "https://furza.co.uk",
  },
  {
    id: 3,
    name: "Are you looking for a cloud service provider?",
    info: "virtualDCS is a cloud service provider specializing in Backup as a Service (BaaS), Disaster Recovery (DRaaS), SaaS backup, and Infrastructure as a Service (IaaS).",
    logo: "/images/offers-images/logos/virtualdcs.jpg",
    backgroundImg: "/images/offers-images/backgrounds/banner.png",
    imgAlt: "virtualDCS",

    overlayId: 3,
    overlayText:
      "virtualDCS is a cloud service provider specializing in Backup as a Service (BaaS), Disaster Recovery (DRaaS), SaaS backup, and Infrastructure as a Service (IaaS). They offer secure, UK-hosted solutions to protect business data, ensure continuity, and enhance cloud resilience, partnering with Veeam, VMware, and Microsoft for robust cloud services.",
    overlayLinkName: "Find out more.",
    overlayOfferLink:
      "http://virtualdcs.co.uk",
  }
];

export default offers;
